import { Injectable } from '@angular/core';
import { get, set, unset } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  key = 'Oko-VipService';

  constructor() {
    this.checkStorage();
  }

  public get(key: string, defaultValue: any = null): any {
    this.checkStorage();
    const storage = JSON.parse(localStorage.getItem(this.key));
    return get(storage, key, defaultValue);
  }

  public set(key: string, value: any) {
    this.checkStorage();
    const storage = JSON.parse(localStorage.getItem(this.key)) || {};
    set(storage, key, value);
    localStorage.setItem(this.key, JSON.stringify(storage));
  }

  public remove(key: string) {
    this.checkStorage();
    const storage = JSON.parse(localStorage.getItem(this.key));
    unset(storage, key);
    localStorage.setItem(this.key, JSON.stringify(storage));
  }

  public clear() {
    localStorage.removeItem(this.key);
  }

  private checkStorage() {
    if (!localStorage.getItem(this.key)) {
      localStorage.setItem(this.key, JSON.stringify({}));
    }
  }
}
